(() => {
  if (customElements.get('jd-showroom')) return;
  // Runs only inside a disposable catalogue iframe, never in the editor/export.
  function catalogPlayback() {
    const native = {
      now: performance.now.bind(performance),
      raf: requestAnimationFrame.bind(window), caf: cancelAnimationFrame.bind(window),
      timeout: setTimeout.bind(window), clear: clearTimeout.bind(window)
    };
    const timers = new Map(), frames = new Map(), pausedAnimations = new Set();
    let serial = 0, paused = false, pauseAt = 0, elapsedPause = 0;
    let started = false, held = false, settling = false, monitor = 0, quietAt = 0;
    const now = () => (paused ? pauseAt : native.now()) - elapsedPause;
    const report = state => parent.postMessage({type:'jd-catalog-state',state}, '*');
    Object.defineProperty(performance, 'now', {value:now, configurable:true});
    function arm(id, timer) {
      timer.due = now() + timer.remaining;
      timer.native = native.timeout(() => {
        if (!timers.has(id)) return;
        if (timer.interval) { timer.remaining = timer.delay; arm(id,timer); }
        else timers.delete(id);
        if (typeof timer.callback === 'function') timer.callback(...timer.args);
      }, timer.remaining);
    }
    function schedule(callback, delay, interval, args) {
      const id = ++serial, ms = Math.max(interval ? 1 : 0, Number(delay)||0);
      const timer = {callback,args,delay:ms,remaining:ms,due:now()+ms,interval};
      timers.set(id,timer); if (!paused) arm(id,timer); return id;
    }
    window.setTimeout = (callback,delay,...args) => schedule(callback,delay,false,args);
    window.setInterval = (callback,delay,...args) => schedule(callback,delay,true,args);
    window.clearTimeout = window.clearInterval = id => {
      const timer = timers.get(id); if (timer) native.clear(timer.native); timers.delete(id);
    };
    function armFrame(id, frame) {
      frame.native = native.raf(() => { frames.delete(id); frame.callback(now()); });
    }
    window.requestAnimationFrame = callback => {
      const id=++serial, frame={callback}; frames.set(id,frame);
      if (!paused) armFrame(id,frame); return id;
    };
    window.cancelAnimationFrame = id => {
      const frame=frames.get(id); if (frame) native.caf(frame.native); frames.delete(id);
    };
    function suspend() {
      if (paused) return;
      const time=now(); pauseAt=native.now(); paused=true;
      for (const timer of timers.values()) { native.clear(timer.native); timer.remaining=Math.max(0,timer.due-time); }
      for (const frame of frames.values()) native.caf(frame.native);
      for (const animation of document.getAnimations()) {
        if (animation.playState==='running'||animation.pending) { pausedAnimations.add(animation); animation.pause(); }
      }
      for (const video of document.querySelectorAll('video')) if (!video.paused) { video.dataset.jdResume=''; video.pause(); }
      native.clear(monitor); report(held?'held':'paused');
    }
    function resume() {
      if (!paused || held) return;
      elapsedPause += native.now()-pauseAt; paused=false;
      for (const animation of pausedAnimations) if (animation.playState==='paused') animation.play();
      pausedAnimations.clear();
      for (const timer of timers.entries()) arm(...timer);
      for (const frame of frames.entries()) armFrame(...frame);
      for (const video of document.querySelectorAll('video[data-jd-resume]')) { delete video.dataset.jdResume; video.play().catch(()=>{}); }
      quietAt=0; report('playing'); check();
    }
    function command(action, values) {
      window.dispatchEvent(new MessageEvent('message',{source:parent,data:{type:'jd-paint-command',action,values}}));
    }
    function check() {
      if (paused||held||!started) return;
      const animations=document.getAnimations();
      const finite=animations.some(a=>Number.isFinite(a.effect?.getComputedTiming().endTime)&&(a.playState==='running'||a.pending));
      const pending=[...timers.values()].some(t=>!t.interval)||frames.size>0;
      const video=[...document.querySelectorAll('video')].some(v=>settling?!v.paused:!v.ended);
      if (finite||pending||video) quietAt=0;
      else if (!quietAt) quietAt=now();
      else if (now()-quietAt>=350) {
        // Keep the actual last frame. Product end() handlers may seek or redraw it.
        held=true; report('completed'); suspend(); return;
      }
      monitor=native.timeout(check,100);
    }
    // Product visibility handlers often jump to their end state. Catalogue visibility
    // is owned by the parent, which pauses the actual clocks and keeps the same frame.
    document.addEventListener('visibilitychange',event=>event.stopImmediatePropagation(),true);
    addEventListener('message',event=>{
      if (event.source!==parent||event.data?.type!=='jd-catalog-command') return;
      const {action,values}=event.data;
      if (action==='pause') { suspend(); return; }
      if (action==='resume') { resume(); return; }
      if (action!=='start'||started) return;
      started=true; report('starting');
      command('update',values);
      // Decode the artwork before starting its timeline. Keep the iframe covered
      // while the product's initial update/end callbacks settle.
      const artwork=[...document.images].map(img=>img.decode ? img.decode().catch(()=>{}) : Promise.resolve());
      Promise.all([...artwork,document.fonts.ready]).then(()=>{
        native.raf(()=>native.raf(()=>{
          command('play');
          // Stage frame zero before revealing, then let the parent resume once.
          for(const animation of document.getAnimations()) {
            if(animation.playState==='running'||animation.pending) {
              animation.pause(); animation.currentTime=0; pausedAnimations.add(animation);
            }
          }
          suspend(); report('ready');
        }));
      });
    });
  }

  const loads = new Map();
  const loadRenderer = url => {
    if (!url) return Promise.reject(Error('Previewbestand ontbreekt'));
    if (!loads.has(url)) loads.set(url,new Promise((resolve,reject)=>{
      const script=document.createElement('script');script.src=url;script.onload=resolve;script.onerror=()=>reject(Error('Preview kon niet laden'));document.head.append(script);
    }));
    return loads.get(url);
  };
  const playingRooms = new Set();
  const state = (media,value) => { media.state=value; media.card.dataset.playback=value; };
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  // The idle card shows the expanded widget, using the original transparent artwork.
  // It is plain DOM: no background videos, hidden renderers or animation loops.
  function expandedPoster(card, design) {
    if (!design?.data?.file || card.querySelector('.jd-room-expanded')) return;
    const media = card.querySelector('.jd-room-media');
    const source = document.querySelector('script[src*="/jd-recovered-tools.js"]')?.src;
    if (!media || !source) return;
    const d=design.data, v=design.defaults;
    const art=new URL('jd-'+(d.season?'season-':'approved-')+d.file+'.webp',source).href;
    const poster=document.createElement('div'); poster.className='jd-room-expanded';
    poster.innerHTML='<img class="jd-room-art" src="'+escape(art)+'" alt="'+escape(design.name)+'" loading="lazy" decoding="async"><div class="jd-room-message"><small>'+escape(v.sxLabel||d.tag||'')+'</small><strong>'+escape(v.title)+'</strong><p>'+escape(v.text)+'</p><span>'+escape(v.button)+'</span></div>';
    media.insertBefore(poster,media.querySelector('.jd-room-play'));
    const cta=poster.querySelector('.jd-room-message span');
    if (/^#[a-f\d]{3,8}$/i.test(v.apaccent||'')) cta.style.backgroundColor=v.apaccent;
    if (/^#[a-f\d]{3,8}$/i.test(v.aponaccent||'')) cta.style.color=v.aponaccent;
    if (v.offer) { const offer=document.createElement('b'); offer.className='jd-room-offer'; offer.textContent=v.offer; poster.append(offer); }
    media.dataset.expanded='';
  }

  const sync = room => {
    const media=room.activeMedia; if (!media || media.state==='starting') return;
    const visible=room.inFocus && !room.dragging && !document.hidden;
    if (media.node.tagName==='VIDEO') {
      if (!visible && !media.node.paused) { media.node.pause(); state(media,'paused'); }
      else if (visible && media.state==='paused') media.node.play().catch(()=>{});
    } else media.node.contentWindow?.postMessage({type:'jd-catalog-command',action:visible?'resume':'pause'},'*');
  };
  const stop = room => {
    if (!room?.activeMedia) return;
    const {node, button, resize} = room.activeMedia;
    state(room.activeMedia,'inactive');
    room.activeMedia = null;
    playingRooms.delete(room);
    resize?.disconnect();
    if (node.tagName === 'VIDEO') node.pause();
    button.parentElement?.removeAttribute('data-playing');
    node.remove();
    button.hidden = false;
  };
  const stopAll = () => [...playingRooms].forEach(stop);
  document.addEventListener('visibilitychange', () => [...playingRooms].forEach(sync));
  addEventListener('pagehide', event => { if (!event.persisted) stopAll(); });
  customElements.define('jd-showroom', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.jd-room-track');
      if (!this.track) return;
      this.cards = [...this.track.children].filter(card => !card.hidden);
      if (!this.cards.length) { this.hidden = true; return; }
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      window.addEventListener('message',event=>{
        const media=this.activeMedia;
        if (!media || event.source!==media.node.contentWindow || event.data?.type!=='jd-catalog-state') return;
        if(event.data.state==='ready') {
          media.node.style.opacity='1';
          media.button.parentElement.setAttribute('data-playing','');
          state(media,'paused'); sync(this); return;
        }
        if(media.state==='starting' && event.data.state==='paused') return;
        if (['starting','playing','paused','completed','held'].includes(event.data.state)) state(media,event.data.state);
      },opts);
      this.queuePreview = () => {
        clearTimeout(this.previewTimer);
        if (!this.inFocus || this.dragging || document.hidden || motion.matches) return;
        const card = this.cards[this.index];
        if (card?.dataset.key?.startsWith('real50-') && !this.design(card) && !this.loadingRenderer && !this.rendererFailed) {
          this.loadingRenderer=true;
          const branch=window.JordigiBranches?Promise.resolve():loadRenderer(this.dataset.branchRenderer);
          branch.then(()=>loadRenderer(this.dataset.videoRenderer)).then(()=>{
            this.loadingRenderer=false;
            for(const item of this.cards){const play=item.querySelector('.jd-room-play');if(play&&this.design(item))play.hidden=false;}
            this.queuePreview();
          }).catch(()=>{this.loadingRenderer=false;this.rendererFailed=true;});
          return;
        }
        const button = card?.querySelector('.jd-room-play');
        if (this.activeMedia?.card === card) { sync(this); return; }
        if (!button || button.hidden) return;
        this.previewTimer = setTimeout(() => {
          if (card === this.cards[this.index] && this.inFocus && !document.hidden && !motion.matches) this.play(button, true);
        }, 220);
      };
      this.focusObserver = new IntersectionObserver(([entry]) => {
        this.inFocus = entry.isIntersecting;
        sync(this);
        this.queuePreview();
      }, {rootMargin:'0px'});
      this.focusObserver.observe(this.track);
      document.addEventListener('visibilitychange',this.queuePreview,opts);
      window.addEventListener('pageshow',this.queuePreview,opts);
      motion.addEventListener('change',() => {
        if (motion.matches && this.activeMedia?.room === this) stop(this);
        this.queuePreview();
      },opts);
      this.index = -1;
      this.dots = document.createElement('span');
      this.dots.className = 'jd-room-dots';
      this.dots.setAttribute('aria-hidden','true');
      this.cards.forEach(() => this.dots.append(document.createElement('i')));
      this.querySelector('output')?.after(this.dots);
      this.onScroll = () => {
        if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); this.queuePreview(); });
      };
      this.track.addEventListener('scroll', this.onScroll, {...opts, passive:true});
      this.resize = new ResizeObserver(this.onScroll);
      this.resize.observe(this.track);
      this.observer = new IntersectionObserver(([entry]) => {
        this.onScreen = entry.isIntersecting;
        this.queuePreview();
        sync(this);
      });
      this.observer.observe(this.track);
      this.addEventListener('keydown', e => {
        if (e.target !== this.track || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault(); this.move(this.index + (e.key === 'ArrowRight' ? 1 : -1));
      }, opts);
      this.track.addEventListener('dragstart', e => e.preventDefault(), opts);
      this.track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('input,select,textarea')) return;
        this.pointer = {id:e.pointerId,x:e.clientX,y:e.clientY,left:this.track.scrollLeft};
      }, opts);
      window.addEventListener('pointermove', e => {
        const p = this.pointer;
        if (!p || e.pointerId !== p.id) return;
        const dx = e.clientX-p.x;
        if (!this.dragging) {
          if (Math.abs(dx)<8 || Math.abs(dx)<Math.abs(e.clientY-p.y)) return;
          this.dragging = true;
          this.track.setPointerCapture(p.id);
          this.track.classList.add('is-dragging');
          clearTimeout(this.previewTimer);
          sync(this);
        }
        e.preventDefault();
        this.track.scrollLeft = p.left-dx;
      }, {...opts,passive:false});
      this.finishDrag = e => {
        if (!this.pointer || e.pointerId !== this.pointer.id) return;
        const dragged = this.dragging;
        this.pointer = null;
        this.dragging = false;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(e.pointerId)) this.track.releasePointerCapture(e.pointerId);
        if (dragged) {
          this.suppressClickUntil = performance.now()+350;
          const distances = this.cards.map(card => Math.abs(this.offset(card)));
          this.move(distances.indexOf(Math.min(...distances)));
          this.queuePreview();
        }
      };
      window.addEventListener('pointerup', this.finishDrag, opts);
      window.addEventListener('pointercancel', this.finishDrag, opts);
      this.addEventListener('click', e => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          e.preventDefault(); e.stopImmediatePropagation(); return;
        }
        const sideCard = e.target.closest('.jd-room-slide');
        if (sideCard && sideCard !== this.cards[this.index]) {
          e.preventDefault(); e.stopImmediatePropagation();
          this.move(this.cards.indexOf(sideCard)); return;
        }
      }, {...opts,capture:true});
      this.addEventListener('click', e => {
        const step = e.target.closest('[data-jd-room-step]');
        if (step) { e.stopPropagation(); this.move(this.index + Number(step.dataset.jdRoomStep)); return; }
        const button = e.target.closest('.jd-room-play');
        if (button) { e.stopPropagation(); this.play(button); }
      },opts);
      this.cards.forEach(card => {
        const button = card.querySelector('.jd-room-play');
        if (button) button.hidden = !(card.querySelector('template') || this.design(card));
        expandedPoster(card,this.design(card));
      });
      if (this.cards.length > 2) this.track.scrollLeft += this.offset(this.cards[Math.min(3,this.cards.length-2)]);
      this.update();
    }
    edgeCard(last) {
      const cards = [...this.track.children].filter(card => !card.hidden);
      return cards[last ? cards.length - 1 : 0];
    }
    design(card) {
      return window.JordigiApproved?.products?.find(p => p.id === card.dataset.key);
    }
    move(index) {
      const card = this.cards[(index + this.cards.length) % this.cards.length];
      const current = this.cards[this.index];
      const align = element => element.offsetLeft + element.offsetWidth/2 - this.track.clientWidth/2;
      // At the seam, put both neighbours in the rail before starting the transition.
      if (this.cards.length > 2 && (card === this.edgeCard(false) || card === this.edgeCard(true))) {
        this.track.style.scrollSnapType = 'none';
        if (index < this.index && current === this.edgeCard(false)) {
          this.track.prepend(card);
          this.track.prepend(this.edgeCard(true));
        } else if (index > this.index && current === this.edgeCard(true)) {
          this.track.append(card);
          this.track.append(this.edgeCard(false));
        } else if (card === this.edgeCard(false)) this.track.prepend(this.edgeCard(true));
        else this.track.append(this.edgeCard(false));
        this.track.scrollLeft = align(current);
        this.track.style.scrollSnapType = '';
      }
      this.track.scrollTo({left:align(card),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
    offset(card) {
      return card.offsetLeft + card.offsetWidth/2 - this.track.scrollLeft - this.track.clientWidth/2;
    }
    update() {
      const distances = this.cards.map(card => Math.abs(this.offset(card)));
      const index = distances.indexOf(Math.min(...distances));
      const current = this.cards[index];
      // Rotate existing cards at the ends. Keep the same visual anchor and media node.
      if (!this.dragging && this.cards.length > 2 && distances[index] < 2) {
        const before = current.offsetLeft;
        if (current === this.edgeCard(false)) this.track.prepend(this.edgeCard(true));
        else if (current === this.edgeCard(true)) this.track.append(this.edgeCard(false));
        const shift = current.offsetLeft - before;
        if (shift) this.track.scrollLeft = current.offsetLeft + current.offsetWidth/2 - this.track.clientWidth/2;
      }
      if (index === this.index && this.lastFirst === this.edgeCard(false)) return;
      this.index = index;
      this.lastFirst = this.edgeCard(false);
      for (const card of this.cards) {
        card.setAttribute('aria-current',String(card === current));
        card.style.setProperty('--side',Math.sign(current.offsetLeft-card.offsetLeft));
      }
      if (this.activeMedia?.room === this && this.activeMedia.card !== current) stop(this);
      this.queuePreview();
      const output = this.querySelector('output');
      if (output) output.textContent = (index+1)+' / '+this.cards.length;
      Array.from(this.dots.children).forEach((dot,i) => dot.classList.toggle('on',i===index));
    }
    play(button, automatic = false) {
      const card = button.closest('.jd-room-slide');
      if (card !== this.cards[this.index]) { this.move(this.cards.indexOf(card)); return; }
      if (document.hidden || !this.onScreen) return;
      stop(this);
      const template = card.querySelector('template');
      const design = this.design(card);
      if (!template && !design) return;
      const node = template ? template.content.firstElementChild.cloneNode(true) : document.createElement('iframe');
      this.activeMedia = {room:this,card,node,button,state:'starting'};
      state(this.activeMedia,'starting');
      playingRooms.add(this);
      if (!template) {
        node.title = design.name;
        node.setAttribute('sandbox','allow-scripts');
        const values={...design.defaults,apRepeat:'off',rxLoop:'off',jdCatalogPreview:true};
        let html = window.JordigiApproved.documentFor(design,values,true);
        const runtime='<script>('+catalogPlayback.toString()+')();<\/script>';
        html=html.replace(/<script\b/i,()=>runtime+'<script');
        const style = '<style>html,body,#canvas,#stage,#widget,.scene,.message{background:transparent!important}#stage{color:#173952!important;--text:#173952!important;--panel:transparent!important}.message,.scene-label,.scene-copy,.message h2{color:#173952!important}</style>';
        node.srcdoc = html.includes('</head>') ? html.replace('</head>',style+'</head>') : html.replace('<body>',style+'<body>');
        const fit = () => {
          const media = button.parentElement;
          const scale = Math.min(media.clientWidth/900,media.clientHeight/650);
          const opacity=node.style.opacity || '0';
          node.style.cssText = 'position:absolute!important;left:50%!important;top:50%!important;width:900px!important;height:650px!important;max-width:none!important;border:0!important;transform:translate(-50%,-50%) scale('+scale+');transform-origin:center;background:transparent;pointer-events:none;opacity:'+opacity;
        };
        const resize = new ResizeObserver(fit);
        this.activeMedia.resize = resize;
        resize.observe(button.parentElement);
        fit();
        node.addEventListener('load', () => {
          if (this.activeMedia?.node !== node) return;
          node.contentWindow.postMessage({type:'jd-catalog-command',action:'start',values},'*');
        },{once:true});
      }
      node.addEventListener('playing',() => {if (this.activeMedia?.node === node) {node.style.opacity='1';button.parentElement.setAttribute('data-playing','');state(this.activeMedia,'playing');}});
      node.addEventListener('ended',() => {if (this.activeMedia?.node === node) { state(this.activeMedia,'completed'); state(this.activeMedia,'held'); }});
      node.addEventListener('error',() => {if (this.activeMedia?.node === node) stop(this);},{once:true});
      if (template) { node.style.opacity='0';node.removeAttribute('poster');node.playsInline = true; node.loop = false; if (automatic) { node.muted = true; node.defaultMuted = true; } }
      button.before(node); button.hidden = true;
      if (template) node.play().catch(() => { if (this.activeMedia?.node === node) stop(this); });
    }
    disconnectedCallback() {
      if (this.activeMedia?.room === this) stop(this);
      clearTimeout(this.previewTimer); this.focusObserver?.disconnect();
      this.dots?.remove();
      this.abort?.abort(); this.abort = null; this.observer?.disconnect(); this.resize?.disconnect();
      cancelAnimationFrame(this.raf); this.raf = 0;
    }
  });
})();





